import TablePlugin from "@wielink/datatables";
import Table from '@/pages/components/table'

export default {
	components: {Table},
	mounted() {
		this.initialiseDatatable();
	},

	props: {
		tableConfig: {
			required: true,
		}
	},

	methods: {
		initialiseDatatable() {
			new TablePlugin({
				scope: this.$refs.table.$refs.table
			});
		}
	}
}